import * as THREE from 'three';
import Translate from './Translate';
import baseFragment from '../Shader/base.frag';
import baseVertex from '../Shader/base.vert';

export default class Fragment extends Translate {
  constructor(params) {
    const { width, height, fragmentShader, vertexShader, colors, size } = params;

    super(
      new THREE.PlaneBufferGeometry(width, height),
      new THREE.RawShaderMaterial({
        transparent: true,
        fragmentShader: fragmentShader || baseFragment,
        vertexShader: vertexShader || baseVertex,
        uniforms: {
          texture: {
            value: params.texture,
          },
          opacity: {
            value: 0,
          },
          frequency: {
            value: Math.random(),
          },
          gradientstart: {
            value: new THREE.Vector3(colors.nStart[0], colors.nStart[1], colors.nStart[2]),
          },
          gradientend: {
            value: new THREE.Vector3(colors.nEnd[0], colors.nEnd[1], colors.nEnd[2]),
          },
          resolution: {
            value: new THREE.Vector2(size.width, size.height),
          },
        },
      }),
    );

    this.width = params.width;
    this.height = params.height;

    this.update(params);
  }
  update(params) {
    const { width, height, repeat, offset, position, opacity = 0, colors, size } = params;
    const geometry = [
      -width / 2,
      height / 2,
      0,
      width / 2,
      height / 2,
      0,
      -width / 2,
      -height / 2,
      0,
      width / 2,
      -height / 2,
      0,
    ];
    const uv = [
      offset.x,
      offset.y + repeat.y,
      offset.x + repeat.x,
      offset.y + repeat.y,
      offset.x,
      offset.y,
      offset.x + repeat.x,
      offset.y,
    ];

    this.geometry.attributes.position.set(geometry);
    this.geometry.attributes.position.needsUpdate = true;
    this.geometry.attributes.uv.set(uv);
    this.geometry.attributes.uv.needsUpdate = true;

    this.material.uniforms.opacity.value = opacity;
    this.material.uniforms.opacity.needsUpdate = true;
    this.material.uniforms.gradientstart.value.set(
      colors.nStart[0], colors.nStart[1], colors.nStart[2],
    );
    this.material.uniforms.gradientstart.needsUpdate = true;
    this.material.uniforms.gradientend.value.set(
      colors.nEnd[0], colors.nEnd[1], colors.nEnd[2],
    );
    this.material.uniforms.gradientend.needsUpdate = true;
    this.material.uniforms.resolution.value.set(size.width, size.height);
    this.material.uniforms.resolution.needsUpdate = true;

    this.randomPosition(position);
  }
  animate(animation) {
    const { transition, rotation, opacity } = animation;

    this.translate(transition);
    this.rotate(new THREE.Vector3(rotation, rotation, rotation));
    this.material.uniforms.opacity.value = Math.max(Math.min(opacity, 1), 0);
    this.material.uniforms.opacity.needsUpdate = true;
  }
}



// WEBPACK FOOTER //
// ./src/scene/Object/Fragment.js